<script lang="ts">
	import { AdvancedCardV2 } from '@Shelly/shelly-design-system';
	import { translateTemplateTitle } from 'src/helpers/xt1_helpers/template_helpers';
	import VirtualBooleanButton from 'src/components/DevicesSettings/VirtualComponents/Components/VirtualBooleanButton.svelte';
	import VirtualButton from 'src/components/DevicesSettings/VirtualComponents/Components/VirtualButton.svelte';
	//Components
	import TemplateLabelV2 from './TemplateLabelV2.svelte';
	import TemplateSliderV2 from './TemplateSliderV2.svelte';
	import TemplateProgressbarV2 from './TemplateProgressbarV2.svelte';
	import TemplateFieldV2 from './TemplateFieldV2.svelte';
	import TemplateDropdownV2 from './TemplateDropdownV2.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';
	import { devices_config } from '@devices/index';
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { getGen1DeviceStatuses, createGen1StatusLabels } from '../../../Gen1/gen1-main-helpers';
	import { real_id } from 'src/helpers/interface_helpers';
	import DeviceLabelList from 'src/components/Sidepanel/DeviceViews/DeviceLabelList.svelte';

	export let device: Device, statuses: VCInterfaceStatus[];

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: deviceConfig = devices_config?.[device?.type];
	$: _statuses = getGen1DeviceStatuses(status, device, settings, deviceConfig);
	$: labelList = createGen1StatusLabels(_statuses);
</script>

<DeviceNotificationLabel deviceId={device?.id} />

{#each statuses as status}
	{#if !status.hideLabel || status.hasAction}
		{@const view = status?.config?.meta?.ui?.view}
		{#if view === 'slider'}
			<TemplateSliderV2 {device} {status} />
		{:else if view === 'progressbar'}
			<TemplateProgressbarV2 {status} />
		{:else if view === 'field'}
			<TemplateFieldV2 {device} {status} type={status.vcType} />
		{:else if view === 'dropdown' || view === 'select'}
			<TemplateDropdownV2 {device} {status} />
		{:else if status.hasAction}
			<AdvancedCardV2 title={translateTemplateTitle(status.name)} size="m" class="mb-s">
				<svelte:fragment slot="right">
					{#if status.vcType == 'boolean'}
						<VirtualBooleanButton
							{device}
							componentID={status.id}
							value={status.event}
							icon="fa fa-power-off"
						/>
					{:else}
						<VirtualButton
							{device}
							componentID={status.id}
							value={status.event}
							icon={status.icon || 'fa fa-power-off'}
						/>
					{/if}
				</svelte:fragment>
			</AdvancedCardV2>
		{:else}
			<TemplateLabelV2 {status} />
		{/if}
	{/if}
{/each}
